import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '搜索', to: '/search' },
  { label: '关于', to: '/about' },
  { label: '联系', to: '/contact' },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const transparent = isHome && !scrolled && !menuOpen;

  const shell = transparent
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur border-b border-background-200';

  const linkBase = 'px-3.5 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap';
  const linkIdle = transparent
    ? 'text-background-100 hover:text-background-50'
    : 'text-foreground-600 hover:text-foreground-950';

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${shell}`}>
      <div className="flex h-16 items-center justify-between px-4 md:px-8 lg:px-10">
        <Link to="/" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              transparent ? 'bg-background-50/20 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-base font-bold tracking-tight ${
                transparent ? 'text-background-50' : 'text-foreground-950'
              }`}
            >
              日韩中文字幕
            </span>
            <span
              className={`mt-0.5 text-[10px] uppercase tracking-[0.18em] ${
                transparent ? 'text-background-200' : 'text-foreground-400'
              }`}
            >
              Subtitle Hub
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `${linkBase} ${
                  isActive
                    ? transparent
                      ? 'text-accent-300'
                      : 'text-accent-600'
                    : linkIdle
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            className={`hidden h-9 items-center gap-2 rounded-full border px-4 text-sm transition-colors md:inline-flex ${
              transparent
                ? 'border-background-50/40 text-background-50 hover:bg-background-50/15'
                : 'border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600'
            }`}
          >
            <i className="ri-search-line"></i>
            查找字幕
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
            className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors md:hidden cursor-pointer ${
              transparent ? 'text-background-50 hover:bg-background-50/15' : 'text-foreground-800 hover:bg-background-100'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-300"></i>
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}